import 'whatwg-fetch';
import HttpConfig from "../config/HttpConfig"
import * as HttpService from "./HttpService"
import { encryptByAES,decryptedByAES } from '../utils/Crypto';

const DOMAIN = HttpConfig.HTTP_APPLICATION_SERVER;

const HTTP_AUTHORIZATION_SERVER_URL = HttpConfig.HTTP_AUTHORIZATION_SERVER_URL;

const CLIENT_BASIC_AUTH = HttpConfig.CLIENT_BASIC_AUTH; // 请求认证服务器basic加密



/**
 * 获取用户信息
 */
export const getUserInfo = () => {
    return HttpService.get(DOMAIN + "/loadAuthUser");
}

/**
 * 插入登录日志
 */
export const addLoginLog = (params) => {
    return HttpService.post(DOMAIN + "/LoginLog/addLoginMessage",params);
}

/**
 * 获取项目列表
 */
export const getProjectList = () => {
    return HttpService.get(DOMAIN + "/loadAuthFirstMenuList");
}

/**
 * 根据项目id获取菜单列表
 * @param parentId 项目id
 */
export const getMenuListByProjectId = (parentId) => {
    return HttpService.post(DOMAIN + "/loadAuthAllMenuTree?parentId=" + parentId);
}
/**
 * 修改密码
 * @param oldPassword 原密码
 * @param newPassword 新密码
 */
export const changePassword = (oldPassword, newPassword) => {
    return HttpService.post(DOMAIN + "/modifyPassword?oldPassword=" + oldPassword + "&newPassword=" + newPassword);
}
/**
 * 编辑个人信息
 * @param profile
 */
export const editProfile = (profile) => {
    const fd = new FormData();
    fd.append("userFullname", profile.userFullname)
    fd.append("userMobile", profile.userMobile)
    return HttpService.postForm(DOMAIN + "/modifyProfile", fd);
}

/**
 * 登录
 * @param username 用户名
 * @param password 密码
 */
export const login = (username, password) => {
    const pwd = username + "@@" + encryptByAES(password);
    let formData = new FormData();
    formData.append('grant_type','password');
    formData.append('username', username);
    formData.append('password', pwd);
    formData.append('scope', 'all');
    return request(HTTP_AUTHORIZATION_SERVER_URL,  {
        method: 'POST',
        body: formData,
        headers: {'Authorization': CLIENT_BASIC_AUTH}
    });
}


/**
 * 封装fetch请求，支持异常捕获
 * @param url
 * @param options
 * @returns {Promise<Response>}
 */
export function request(url, options) {
    let opt = options||{};
    return fetch(url, {...opt})
        .then(checkStatus)
        .then(parseJSON)
        .then((data) => ( data ));
}
function checkStatus(response) {
    if (response.status >= 200 && response.status < 300) {
        return response;
    }
    const error = new Error(response.statusText);
    error.response = response;
    throw error;
}
function parseJSON(response) {
    return response.json();
}
